import * as React from 'react';
const { useState, useEffect, useCallback } = React;
import { useAssistantChat } from '../hooks/useAssistantChat';
import * as api from '../services/assistantApi';
import type { ChatConversation } from '../types/assistant';

export const AssistantConversationList: React.FC = () => {
  const [conversations, setConversations] = useState<ChatConversation[]>([]);
  const [loading, setLoading] = useState(true);
  const { loadConversation, startNewConversation } = useAssistantChat();

  useEffect(() => {
    api.listConversations()
      .then((data) => setConversations(data.conversations))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = useCallback((id: number) => {
    loadConversation(id);
  }, [loadConversation]);

  const handleNew = useCallback(async () => {
    await startNewConversation();
  }, [startNewConversation]);

  return (
    <div style={{ padding: 12, overflowY: 'auto', flex: 1 }}>
      <button
        onClick={handleNew}
        style={{
          width: '100%',
          padding: '10px 12px',
          background: '#2C5282',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 12,
        }}
      >
        <i className="fas fa-plus" style={{ marginRight: 6 }} />
        New Conversation
      </button>
      {loading && (
        <div style={{ textAlign: 'center', color: '#a0aec0', padding: 20 }}>
          <i className="fas fa-spinner fa-spin" />
        </div>
      )}
      {!loading && conversations.length === 0 && (
        <div style={{ textAlign: 'center', color: '#a0aec0', padding: 20, fontSize: 13 }}>
          No conversations yet
        </div>
      )}
      {conversations.map((conv) => (
        <div
          key={conv.id}
          onClick={() => handleSelect(conv.id)}
          style={{
            padding: '10px 12px',
            borderRadius: 8,
            cursor: 'pointer',
            marginBottom: 4,
            background: '#f7fafc',
            transition: 'background 0.15s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#edf2f7')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#f7fafc')}
        >
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>{conv.title}</div>
          <div style={{ fontSize: 11, color: '#a0aec0' }}>
            {conv.message_count} messages &middot; {new Date(conv.updated_at).toLocaleDateString()}
          </div>
        </div>
      ))}
    </div>
  );
};
